import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Map from "../Map";
import Sidebar from "../Sidebar";
import GeneralInfo from "../GeneralInfo";
import CanonicalLink from "../CanonicalLink";
import RightFixedBanner from "../RightFixedBanner";
import Notification from "ati-ui-react/widgets/Notification";
import styles from "./Root.scss";
import LdJson from "../LdJson";
import {withNamespaces} from "react-i18next";

const Root = ({
                isPreinitialized,
                isInitialized,
                checkIfAppIsInitialized,
                init,
                showLightVersion,
                isRouteSearchFailed,
                searchRouteError,
                hideErrorNotification,
                t
              }) => {
  // аналог componentDidMount
  useEffect(() => {
    // workaround to fix style blinking
    const timer = setTimeout(() => {
      checkIfAppIsInitialized();
    }, 100);

    return () => clearTimeout(timer); // cleanup на размонтирование
  }, [checkIfAppIsInitialized]);

  // аналог componentDidUpdate(prevProps)
  useEffect(() => {
    if (isPreinitialized) {
      init();
    }
  }, [isPreinitialized, init]);

  /** @param {SearchRouteError} searchRouteError
   * @param t
   */
  const generateErrorMessage = (searchRouteError, t) => {
    let message = t(`trace-general-errors-${searchRouteError.error}`, searchRouteError.reason);
    if(searchRouteError.errorList && searchRouteError.errorList.length > 0){
      searchRouteError.errorList.forEach((errorItem) => {
        let key = errorItem.error;
        if(key === "argument_out_of_range" || key === "enum_contains_in"){
          try{
            key = "invalid_" + errorItem.reason.split(':')[0].split('.')[1];
          }
          catch (e) {
            key = errorItem.error;
          }
        }
        message += '\r\n • ' + t(`trace-general-errors-${key}`, errorItem.reason);
      });
    }
    return message;
  };

  /** @param {SearchRouteError} searchRouteError */
  const getNotificationType = (searchRouteError)=>{
    return searchRouteError.status >= 500 ? "error" : "warning";
  };

  return (
    <>
      <LdJson />
      <Map />
      <CanonicalLink />
      {isInitialized && (
        <div className={styles.container}>
          {!showLightVersion && <Sidebar />}
          {!showLightVersion && <GeneralInfo />}
          {!showLightVersion && <RightFixedBanner />}
        </div>
      )}
      {searchRouteError &&
        <div className={styles.notification}>
          <Notification
            show={isRouteSearchFailed}
            type={getNotificationType(searchRouteError)}
            delay={4000}
            message={generateErrorMessage(searchRouteError, t)}
            closeNotification={hideErrorNotification}
          />
        </div>
      }
      <div id="legend-popup-container" />
    </>
  );
};

Root.defaultProps = {
  showLightVersion: false
};

Root.propTypes = {
  isPreinitialized: PropTypes.bool.isRequired,
  isInitialized: PropTypes.bool.isRequired,
  checkIfAppIsInitialized: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  showLightVersion: PropTypes.bool
};

export default withNamespaces()(Root);
